export const INVOICE_ADDRESS_SET_ADDRESS = 'INVOICE_ADDRESS_SET_ADDRESS'
export const INVOICE_ADDRESS_SET_ADDRESSES = 'INVOICE_ADDRESS_SET_ADDRESSES'
